import React,{useState} from 'react'
import { useAppData } from '../../context/AppDataContext'
import { GroupAdd } from '@mui/icons-material';
import { Dialog, DialogContent } from '@mui/material';
import ReceivedPendingRequestList from '../../app/associate/profile/component/ReceivedPendingRequestList';

function JoinRequest() {

    const {receivedJoinRequest} = useAppData();    
    const [dialogStatus, setDialogStatus] = useState(false);

    return (
        receivedJoinRequest?.length > 0 &&
        <>  
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}    
                maxWidth="md"
                fullWidth={true}
            >
                <DialogContent>
                    <ReceivedPendingRequestList receivedPendingRequest={receivedJoinRequest} />
                    
                    {/*
                    <table className='table'>
                        {receivedJoinRequest.map(clinic=>
                            <tr key={clinic.clinicId}>
                                <td>{clinic.title}</td>
                            </tr>
                        )}
                    </table>
                    */}
                </DialogContent>

            </Dialog>
            <button className='btn btn-success position-relative' onClick={()=>setDialogStatus(true)}>
                <GroupAdd/>
                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{receivedJoinRequest.length}</span>
            </button>
        </>
    )
}

export default JoinRequest